var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"pui-app-sidebar pui-app-sidebar__root"},[_c('ul',{staticClass:"pui-app-sidebar__list"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }